import React from 'react'
import { ImageWithFallback } from 'components'
import { thunks as MarketThunks } from 'reducers/Market'
import { marketOptions } from 'constants/enums'

const formatLabelCell = (field) => {
  return (
    <>
      {field[0] && (
        <div className="flex">
          <div className="truncate">{field[0].name}</div>
          <span className="flex-none whitespace-pre">{field[1] && ' /'}</span>
        </div>
      )}
      {field[1] && <div className="truncate">{field[1].name}</div>}
    </>
  )
}

const formatMarketsCell = (markets, marketTags) => {
  const marketIcons = marketTags.map((item) => {
    for (let i = 0; i < markets.length; i++) {
      if (markets[i].id === item) {
        const url = MarketThunks.getMarketLogoSrc(
          markets[i].icon,
          marketOptions.white,
          marketOptions.two
        )()
        return (
          <ImageWithFallback
            key={`${item}`}
            className="w-6 h-6 mb-2"
            src={url}
            alt={item}
          />
        )
      }
    }
    return ''
  })
  return <div className="flex w-full justify-around">{marketIcons}</div>
}

export default { formatLabelCell, formatMarketsCell }
